import {
  BLOCKED_NOTE_ATTACHMENT_EXTENSIONS,
  SUPPORTED_NOTE_ATTACHMENT_EXTENSIONS,
} from "../constants/noteAttachment.constants";

/**
 * Reads the attachment list from a fetched note, supporting both the current
 * `attachments` array and the legacy single `attachment` object.
 * @param {{ attachments?: object[], attachment?: object } | null | undefined} noteData
 * @returns {object[]}
 */
export const readNoteAttachments = (noteData) => {
  if (Array.isArray(noteData?.attachments)) return noteData.attachments;

  return noteData?.attachment ? [noteData.attachment] : [];
};

/**
 * Stable identity for a picked browser file, used to de-duplicate selections
 * and key list rows before the file has a server-side blob name.
 * @param {File} file
 * @returns {string}
 */
export const getAttachmentFileKey = (file) =>
  `${file.name}:${file.size}:${file.lastModified}`;

const SUPPORTED_FILE_TYPES_DESCRIPTION =
  "images, PDF, Word, PowerPoint, Excel/CSV, text/data, and code files";

const getFileExtension = (fileName = "") => {
  const extensionStartIndex = fileName.lastIndexOf(".");
  if (extensionStartIndex <= 0) return "";

  return fileName.slice(extensionStartIndex).toLowerCase();
};

const buildBlockedFileMessage = (extension) => {
  return `${extension} files are not supported for security reasons.`;
};

const buildUnsupportedFileMessage = (extension) => {
  const fileType = extension || "Files without an extension";
  return `${fileType} are not supported. Upload ${SUPPORTED_FILE_TYPES_DESCRIPTION}.`;
};

/**
 * @param {File} file - Browser file selected by the user.
 * @returns {{ isValid: boolean, message?: string }}
 */
export const validateNoteAttachmentFile = (file) => {
  const extension = getFileExtension(file?.name);

  if (BLOCKED_NOTE_ATTACHMENT_EXTENSIONS.includes(extension)) {
    return {
      isValid: false,
      message: buildBlockedFileMessage(extension),
    };
  }

  if (!SUPPORTED_NOTE_ATTACHMENT_EXTENSIONS.includes(extension)) {
    return {
      isValid: false,
      message: buildUnsupportedFileMessage(extension),
    };
  }

  return { isValid: true };
};
